export default {"src":"/_next/static/media/competitive-exchange-rates.c41c377b.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};